module.exports = __webpack_public_path__ + "static/media/Template_24.c21ea9e6.png";